import { render, staticRenderFns } from "./LabelPicker.vue?vue&type=template&id=6dde3fc6&scoped=true&"
import script from "./LabelPicker.vue?vue&type=script&lang=js&"
export * from "./LabelPicker.vue?vue&type=script&lang=js&"
import style0 from "./LabelPicker.vue?vue&type=style&index=0&id=6dde3fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde3fc6",
  null
  
)

export default component.exports